import { AxiosError } from 'axios';
import api from '../../../services/api';

export async function deleteCompetenceRequest(id: number) {
	try {
		const response = await api.delete(`/competence/${id}`);

		return response.data;
	} catch (error) {
		if (error instanceof AxiosError) {
			throw new Error(error.response?.data?.message);
		} else {
			throw new Error();
		}
	}
}
